
/** De pagina achter een lade vastzetten. Gedeeld door de winkelwagen; het menu
    heeft zijn eigen versie in de header-sectie. */
let casanuvaBewaardeScroll = 0;

function casanuvaZetVast() {
  // Al op slot? Dan niets opnieuw meten: window.scrollY is dan 0 en dat zou de
  // bewaarde positie overschrijven.
  if (document.body.style.position === 'fixed') return;
  casanuvaBewaardeScroll = window.scrollY || document.documentElement.scrollTop || 0;
  document.documentElement.style.overflow = 'hidden';
  document.body.classList.add('overflow-hidden');
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + casanuvaBewaardeScroll + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
}

function casanuvaLaatLos() {
  document.documentElement.style.overflow = '';
  document.body.classList.remove('overflow-hidden');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  window.scrollTo(0, casanuvaBewaardeScroll);
}
/**
 * Casanuva Cart Drawer
 * Custom cart drawer with quantity management, cross-sells, and shipping bar.
 */

function casanuvaRenderSections(state, sections) {
  sections.forEach((section) => {
    const targetEl = document.querySelector(section.selector);
    if (!targetEl || !state.sections || !state.sections[section.section]) return;

    const parsed = new DOMParser().parseFromString(state.sections[section.section], 'text/html');

    if (section.section === 'cart-drawer') {
      // Extract content from inside <casanuva-cart-drawer> in the response
      const sourceDrawer = parsed.querySelector('casanuva-cart-drawer');
      if (sourceDrawer) {
        targetEl.innerHTML = sourceDrawer.innerHTML;
      }
    } else {
      const sourceEl = parsed.querySelector('.shopify-section');
      if (sourceEl) targetEl.innerHTML = sourceEl.innerHTML;
    }
  });

}

function casanuvaGetSections() {
  return [
    { id: 'cart-drawer', section: 'cart-drawer', selector: 'casanuva-cart-drawer' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#shopify-section-cart-icon-bubble' },
  ];
}


class CasanuvaCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector('#CasanuvaDrawer');
    this.overlay = this.querySelector('#CasanuvaDrawer-Overlay');

    // All event handling via delegation on the custom element — survives innerHTML swaps
    this.addEventListener('click', (e) => {
      // Close button
      if (e.target.closest('#CasanuvaDrawer-Close')) {
        this.close();
        return;
      }

      // Remove button
      const removeBtn = e.target.closest('.casanuva-drawer__item-remove');
      if (removeBtn) {
        e.preventDefault();
        this.updateQuantity(removeBtn.dataset.index, 0);
        return;
      }

      // Quantity +/- buttons
      const quantityBtn = e.target.closest('.casanuva-drawer__quantity-btn');
      if (quantityBtn) {
        e.preventDefault();
        const index = quantityBtn.dataset.index;
        const input = this.querySelector(`#CasanuvaDrawer-Quantity-${index}`);
        if (!input) return;
        const currentQty = parseInt(input.value);
        const newQty = quantityBtn.name === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        input.value = newQty;
        this.updateQuantity(index, newQty);
        return;
      }

      // Cross-sell add button
      // Knoppen met data-quick-add gaan naar het keuzepaneel. Beide
      // afhandelingen hangen aan document, dus stopPropagation daar houdt deze
      // niet tegen — overslaan moet hier gebeuren.
      const crossSellAdd = e.target.closest('.casanuva-drawer__cross-sell-add');
      if (crossSellAdd && !crossSellAdd.hasAttribute('data-quick-add')) {
        e.preventDefault();
        this.addCrossSell(crossSellAdd);
        return;
      }
    });

    // Overlay click to close — also delegated
    document.addEventListener('click', (e) => {
      if (e.target.closest('#CasanuvaDrawer-Overlay')) {
        this.close();
      }
    });

    // Escape key
    document.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') this.close();
    });

    // Quantity input direct change
    this.addEventListener('change', (e) => {
      const input = e.target.closest('.casanuva-drawer__quantity-value');
      if (input) {
        clearTimeout(this._debounce);
        this._debounce = setTimeout(() => {
          this.updateQuantity(input.dataset.index, Math.max(0, parseInt(input.value) || 0));
        }, 300);
      }
    });

    // Subscribe to cart updates from other sources
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'casanuva-cart-drawer' || event.source === 'product-form') return;
        this.onCartUpdate();
      });
    }

    // Cart icon integration
    this.setCartIconAccessibility();
  }

  setCartIconAccessibility() {
    // Support Dawn's #cart-icon-bubble and all Casanuva cart links
    const cartIcons = [
      document.querySelector('#cart-icon-bubble'),
      ...document.querySelectorAll('a.cnv-hdr-icon[href*="/cart"]')
    ].filter(Boolean);

    if (cartIcons.length === 0) return;
    this.cartIcon = cartIcons[0];

    cartIcons.forEach((icon) => {
      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-haspopup', 'dialog');
      icon.setAttribute('aria-expanded', 'false');

      icon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      icon.addEventListener('keyup', (e) => {
        if (e.code === 'Space') {
          e.preventDefault();
          this.open();
        }
      });
    });
  }

  open() {
    // Re-grab in case of innerHTML swap
    this.drawer = this.querySelector('#CasanuvaDrawer');
    this.overlay = this.querySelector('#CasanuvaDrawer-Overlay');

    if (this.drawer) this.drawer.classList.add('is-active');
    if (this.overlay) this.overlay.classList.add('is-active');
    // Een klasse op body is niet genoeg: op mobiel scrollt html, dus de pagina
    // liep gewoon door achter de lade. Body vastzetten op zijn plek is de enige
    // aanpak die op iOS werkt; de scrollpositie bewaren we zolang.
    casanuvaZetVast();

    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) cartIcon.setAttribute('aria-expanded', 'true');

    if (this.drawer) {
      this.drawer.addEventListener('transitionend', () => {
        const focusTarget = this.querySelector('#CasanuvaDrawer-Close');
        if (focusTarget) trapFocus(this.drawer, focusTarget);
      }, { once: true });
    }
  }

  close() {
    if (this.drawer) this.drawer.classList.remove('is-active');
    if (this.overlay) this.overlay.classList.remove('is-active');
    casanuvaLaatLos();

    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.setAttribute('aria-expanded', 'false');
      removeTrapFocus(cartIcon);
    }
  }

  renderContents(parsedState) {
    casanuvaRenderSections(parsedState, casanuvaGetSections());
    this.open();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateQuantity(index, quantity) {
    const itemElement = document.getElementById(`CasanuvaDrawer-Item-${index}`);
    if (itemElement) itemElement.classList.add('is-loading');

    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: index,
        quantity,
        sections: casanuvaGetSections().map((s) => s.section),
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((state) => {
        const wasOpen = this.drawer && this.drawer.classList.contains('is-active');
        casanuvaRenderSections(state, casanuvaGetSections());
        if (wasOpen) this.open();
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'casanuva-cart-drawer', cartData: state });
        }
      })
      .catch(console.error);
  }

  addCrossSell(button) {
    const variantId = button.dataset.variantId;
    // Tekst uit de vertaling, niet uit de code.
    const klaar = button.dataset.addedLabel || '';
    button.outerHTML = '<span class="casanuva-drawer__cross-sell-added">' + klaar + '</span>';

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: casanuvaGetSections().map((s) => s.section),
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((state) => {
        const wasOpen = this.drawer && this.drawer.classList.contains('is-active');
        casanuvaRenderSections(state, casanuvaGetSections());
        if (wasOpen) this.open();
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'casanuva-cart-drawer', cartData: state });
        }
      })
      .catch(console.error);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const sourceDrawer = parsed.querySelector('casanuva-cart-drawer');
        if (sourceDrawer) {
          const wasOpen = this.drawer && this.drawer.classList.contains('is-active');
          this.innerHTML = sourceDrawer.innerHTML;
          if (wasOpen) this.open();
        }
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    return casanuvaGetSections();
  }
}

customElements.define('casanuva-cart-drawer', CasanuvaCartDrawer);


// Keep casanuva-cart-items as a no-op custom element (Liquid template uses it)
if (!customElements.get('casanuva-cart-items')) {
  customElements.define('casanuva-cart-items', class extends HTMLElement {});
}
